import YandexCounter from "./../../../vg/services/yandex_metrika/yandexMetrika";

function setUrlObserveCatalogSection(catalog) {
	new window.IntersectionObserver(([entry]) => {
		if (entry.isIntersecting) {
			history.pushState(history.state, "", catalog.dataset.link);
			new YandexCounter().hit(catalog.dataset.link);
			return;
		}
	}, {
		root: null,
		threshold: 0.1,
	}).observe(catalog);
}

export {
	setUrlObserveCatalogSection
};
